<template>
  <div
    :class="classes"
    @click="handleOptionSelect"
  >
    <input
      :checked="optionProductIsSelected"
      :id="optionProductInputId"
      :class="radioInputClasses"
      :name="optionProductInputName"
      :value="packageOptionProduct.CatalogPackageOptionProductID"
      type="radio"
    >
    <div class="row hidden-lg">
      <div class="col-xs-9">
        <h3 class="option-product-radio__retail-name">{{ packageOptionProduct.ProductRetailName }}</h3>
      </div>
      <div class="col-xs-3">
        <div :class="radioButtonOuterClasses">
          <div :class="radioButtonInnerClasses"/>
        </div>
      </div>
    </div>
    <div class="row visible-lg">
      <div class="col-lg-8">
        <h3 class="option-product-radio__retail-name">{{ packageOptionProduct.ProductRetailName }}</h3>
      </div>
      <div class="col-lg-2">
        <option-cost
          :package-base-cost="offerPackage.EffectiveCost"
          :cost="packageOptionProduct.Cost"
          :show-as-total="packageOptionProduct.ShowAsTotal"
          :is-per-frame="isPerFrame"
          :show-modifier="packageOptionProduct.Cost > 0"
          :class="optionCostClasses"
        />
      </div>
      <div class="col-lg-2">
        <div :class="radioButtonOuterClasses">
          <div :class="radioButtonInnerClasses"/>
        </div>
      </div>
    </div>
    <div
      v-if="packageOptionProduct.ProductRetailDescription.length > 0"
      class="row"
    >
      <div class="col-xs-12">
        <p class="option-product-radio__retail-description">
          {{ packageOptionProduct.ProductRetailDescription }}
        </p>
      </div>
    </div>
    <div class="row hidden-lg">
      <div class="col-xs-12">
        <option-cost
          :package-base-cost="offerPackage.EffectiveCost"
          :cost="packageOptionProduct.Cost"
          :show-as-total="packageOptionProduct.ShowAsTotal"
          :is-per-frame="isPerFrame"
          :show-modifier="packageOptionProduct.Cost > 0"
          :class="optionCostClasses"
        />
      </div>
    </div>
    <!--
      Currently do not support the custom configured products UIs in the LetterJacket identity. Need to revisit when this functionality gets moved out to other identities.
      <div v-if="hasCustomConfig">
        @Html.Partial("_CustomConfiguredProducts", new CustomConfiguredProductsViewModel() { OfferPackage = Model.OfferPackage, LimitToCatalogPackageOptionProductId = prod.CatalogPackageOptionProductID, IsPreEvent = false })
      </div>
    -->
  </div>
</template>

<script>
import OptionCost from '@Shared/components/catalog/PackageOption/OptionCost'
import ResponsiveBreakpointsMixin from '@Shared/mixins/responsive-breakpoints'

import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'

import GoogleAnalytics from '@Shared/lib/google-analytics'

Vue.use(VueScrollTo)

export default {
  name: 'OptionProductRadio',
  components: {
    OptionCost
  },
  mixins: [
    ResponsiveBreakpointsMixin
  ],
  props: {
    catalogPackageOptionId: { type: Number, default: null, required: true },
    customConfiguredProductsModel: { type: [Object, null], default: null, reuqired: true },
    hasCustomConfig: { type: Boolean, default: false, required: true },
    isPerFrame: { type: Boolean, default: false, required: true },
    optionIndex: { type: Number, default: 0, required: true },
    packageOptionProduct: { type: Object, default: null, required: true },
    productIndex: { type: Number, default: 0, required: true },
    shouldCustomConfigShowSelectedFrameImage: { type: Boolean, default: false, required: true }
  },
  computed: {
    classes () {
      return {
        'option-product-radio': true,
        'option-product-radio--disabled': this.optionProductIsDisabled
      }
    },
    optionProductIsSelected () {
      return this.$store.getters.getOptionProductIsSelected(this.packageOptionProduct)
    },
    optionProductIsDisabled () {
      return this.$store.getters.getOptionProductIsDisabled(this.packageOptionProduct)
    },
    offerPackage () {
      return this.$store.state.catalogPageCommon.offerPackage
    },
    optionProductInputId () {
      return `option-product-radio-${this.packageOptionProduct.CatalogPackageOptionProductID}`
    },
    optionProductInputName () {
      return `OptionProductIDForPackageOption_${this.catalogPackageOptionId}`
    },
    optionCostClasses () {
      return {
        'option-product-radio__price': true,
        'option-product-radio__price--with-description': this.packageOptionProduct.ProductRetailDescription.length > 0,
        'text-right': this.isDesktop
      }
    },
    radioInputClasses () {
      return {
        'radio-button__input': true
      }
    },
    radioButtonOuterClasses () {
      return {
        'radio-button__outer': true,
        'radio-button__outer--with-description': this.packageOptionProduct.ProductRetailDescription.length > 0,
        'radio-button__outer--selected': this.optionProductIsSelected,
        'radio-button__outer--disabled': this.optionProductIsDisabled
      }
    },
    radioButtonInnerClasses () {
      return {
        'radio-button__inner': true,
        'radio-button__inner--selected': this.optionProductIsSelected,
        'radio-button__inner--disabled': this.optionProductIsDisabled
      }
    },
    zOrder () {
      return this.optionIndex + this.productIndex
    }
  },
  watch: {
    optionProductIsDisabled (v, ov) {
      if (v === true && this.optionProductIsSelected === true) {
        this.$store.dispatch('removeSelectedOptionProduct', { packageOptionProduct: this.packageOptionProduct })
      }
    }
  },
  mounted () {
    const configuredOptionProductId = this.$store.getters.getConfiguredValue(this.optionProductInputName)

    if (configuredOptionProductId === this.packageOptionProduct.CatalogPackageOptionProductID.toString()) {
      this.addOptionProduct(false)
    }
  },
  methods: {
    handleOptionSelect () {
      if (!this.optionProductIsDisabled) {
        GoogleAnalytics.trackEvent(
          'Option Product Radio',
          'click',
          this.packageOptionProduct.ProductRetailName // TODO use internal name intead?
        )

        this.addOptionProduct(true)
      }
    },
    addOptionProduct (doScroll) {
      this.$store.dispatch('addOneSelectedOptionProductPerCatalogPackageOption', { optionProduct: this.packageOptionProduct, catalogPackageOptionId: this.catalogPackageOptionId, zOrder: this.zOrder })

      if (doScroll === true) {
        if (this.packageOptionProduct.LetterJacketProductCaptions !== null && this.packageOptionProduct.LetterJacketProductCaptions.length > 0) {
          if (this.isMobile === true) {
            // if option product has captions and screen is mobile-sized then scroll the user to the new caption UI
            this.$nextTick(() => {
              this.$scrollTo(`#option-product-configuration-${this.packageOptionProduct.CatalogPackageOptionProductID}`)
            })
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import './scss/option-product.scss'; // shared styles

// component specific styles
.option-product-radio {
  cursor: pointer;

  @include option-product-mixin;

  &__price {
    &--with-description {
      margin-top: 8px;
    }
  }
}

.radio-button {
  &__outer {
    background-color: #fff;
    border-radius: 50%;
    border: 1px solid #494949;
    height: 22px;
    margin: 0 auto 0 auto;
    transition: all 200ms ease-in-out;
    width: 22px;

    &--with-description {
      margin-top: 8px;
    }

    &--disabled {
      background-color: #e2e2e2;
      cursor: not-allowed;
    }
  }

  &__inner {
    &--selected {
      background-color: $letterjacket-color-blue;
      border: 2px solid #fff;
      border-radius: 50%;
      height: 20px;
      width: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/letter-jackets/catalog-details/components/PackageOptions/OptionProduct/OptionProductRadio.vue